import { render, staticRenderFns } from "./CandidateItemInfo.vue?vue&type=template&id=5d69d7b8&scoped=true"
import script from "./CandidateItemInfo.vue?vue&type=script&lang=js"
export * from "./CandidateItemInfo.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemInfo.vue?vue&type=style&index=0&id=5d69d7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d69d7b8",
  null
  
)

export default component.exports